import { AlertTriangle, Siren } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTickerAlerts } from '../../hooks/useTickerAlerts'
import { cn } from '../../lib/utils'

/** 顶部全局紧急告警滚动条：无缝滚动，点击跳转事件详情 */
export function AlertTicker() {
  const alerts = useTickerAlerts()
  const navigate = useNavigate()

  if (alerts.length === 0) {
    return (
      <div className="flex h-9 flex-1 items-center gap-2 border-y border-border bg-foreground/[.02] px-4 text-[11px] text-muted-foreground/60">
        <Siren size={13} className="text-success" />
        当前无进行中的应急事件
      </div>
    )
  }

  const items = [...alerts, ...alerts] // 复制两份实现无缝滚动
  return (
    <div className="relative flex h-9 flex-1 items-center overflow-hidden border-y border-[var(--critical-soft)] bg-[var(--critical-soft)]/60">
      <div className="z-10 flex h-full shrink-0 items-center gap-1.5 bg-[var(--critical-soft)] px-3 text-[11px] font-medium text-critical">
        <AlertTriangle size={13} className="animate-emergency-pulse" />
        紧急事件
      </div>
      <div className="flex min-w-0 flex-1 overflow-hidden">
        <div className="animate-ticker flex shrink-0 items-center gap-8 pl-6" key={alerts.map((a) => a.key).join('|')}>
          {items.map((alert, i) => (
            <button
              key={`${alert.key}-${i}`}
              onClick={() => alert.eventId && void navigate(`/events/${alert.eventId}`)}
              className="flex shrink-0 items-center gap-2 text-[11px] text-foreground/80 transition hover:text-foreground"
            >
              <span
                className={cn(
                  'size-1.5 rounded-full',
                  alert.level === 'critical' ? 'bg-critical' : alert.level === 'warning' ? 'bg-warning' : 'bg-watch',
                )}
              />
              {alert.title}
              <span className="text-muted-foreground/60">›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
